module.exports = __webpack_public_path__ + "img/paint.1712fa78.svg";